export default __webpack_public_path__ + "static/media/034-changing.470b2a55.png";